export default function pick<T>(obj: T, properties: Array<keyof T>) {
  return properties.reduce((newObject, prop) => {
    newObject[prop] = obj[prop];
    return newObject;
  }, {} as Partial<T>);
}
